import React from "react";
import { UserContext } from "../contexts";
import { useChatSummary } from "./useMerchantChat";

/**
 * Unread-count badge on the sidebar's Messages entry. Shares the
 * react-query summary key with the chat page, so both surfaces agree and
 * only one poll runs. Renders nothing at 0 (same rule as the
 * notifications badge — a permanent grey "0" is noise).
 */
const MerchantChatNavBadge = () => {
  const { user } = React.useContext(UserContext) ?? {};
  const { data } = useChatSummary(!!user);
  const count = data?.unread_count ?? 0;

  if (!user || count <= 0) return null;

  return (
    <span className="rc-sidebar__badge" aria-label={`${count} unread messages`}>
      {count > 99 ? "99+" : count}
    </span>
  );
};

export default MerchantChatNavBadge;
